import * as React from "react";
import { useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";

export default function Logout() {
  const { logout, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    // Clear admin status cache on logout
    sessionStorage.removeItem('admin_status_cache');
    
    // Only logout if authenticated, otherwise redirect immediately
    if (!isLoading) {
      if (isAuthenticated) {
        // Logout and redirect to sign-in page
        logout({
          logoutParams: {
            returnTo: window.location.origin + "/sign-in",
          },
        });
      } else {
        // If not authenticated, redirect to sign-in immediately
        window.location.href = "/sign-in";
      }
    }
  }, [isAuthenticated, isLoading, logout]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
      }}
    >
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="body1" color="text.secondary">
        Logging out...
      </Typography>
    </Box>
  );
}
